<template>
  <div class="brainsmap-container">
    <div :id="'viewDivDEMO' + mapID" style="height: 100%" />
    <div v-if="legendActive" class="legendcontrol">
      <div v-if="activelegend" class="popover-legend" width="200">
        <!-- <i class="el-icon-close iconclosebrains" @click="activelegend = false" /> -->
        <div class="container-legend">
          <div class="sub-title-legend">{{ legendtitle }}</div>
          <hr style="width: 100%; margin-left: -4px; border: 1px solid #1e3cff; margin-right: auto; background-color: #1e3cff">
          <div class="sub-title-legend">{{ $t('maps.census') }}</div>
          <div v-for="item in legendstops" :key="item.label" class="legenditemcontainer">
            <div class="legendcoloritem" :style="{ 'background-color': item.color }" />
            <div class="legendlabelitem">{{ item.label }} {{ item.unit }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import mapvisualizationoptionsjson from '@/views/search/mapFiltersData.json'
import { mapState } from 'vuex'
import { loadModules } from 'esri-loader'
import { getMapVisualization } from '@/api/maps'

export default {
  components: { },
  props: {
    mapID: {
      type: String,
      default: 'default-map'
    },
    geolevels: {
      type: Array,
      default: () => []
    },
    latitude: {
      type: Number,
      default: 0
    },
    longitude: {
      type: Number,
      default: 0
    },
    legendtitle: {
      type: String,
      default: 'default-title'
    },
    zoom: {
      type: Number,
      default: 13
    },
    legendActive: {
      type: Boolean,
      default: true
    },
    basemap: {
      type: String,
      default: 'topo-vector'
    },
    opacity: {
      type: Number,
      default: 0.7
    }
  },
  data: () => ({
    // ...mapvisualizationoptionsjson,
    activelegend: true,
    currentMap: null,
    currentMapView: null,
    currentVectorLayer: null,
    centerGraphic: null,
    legendstops: []
  }),
  computed: {
    ...mapState('maps', {
      maptoken: (state) => state.token
    }),
    countryName() {
      if (this.geolevels.length === 0) return 'Spain'
      return this.geolevels.filter((item) => item.level === 0)[0].name
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      const vm = this
      getMapVisualization({
        id: vm.mapID,
        country: vm.countryName,
        env: window._env_.VUE_APP_ENV_ARCGIS_SUFFIX === '_DEV' ? 'DEV' : 'PRO'
      }).then((responsed) => {
        const response = responsed.data
        loadModules([
          'esri/config',
          'esri/identity/IdentityManager',
          'esri/layers/VectorTileLayer',
          'esri/Map',
          'esri/views/MapView',
          'esri/geometry/Point',
          'esri/Graphic',
          'esri/core/watchUtils'
        ], { css: true }).then(([
          esriConfig,
          IdentityManager,
          VectorTileLayer,
          ArcGISMap,
          MapView,
          Point,
          Graphic,
          watchUtils
        ]) => {
          var servergis = 'https://auragis.westeurope.cloudapp.azure.com'
          esriConfig.portalUrl = servergis + '/portal'
          IdentityManager.registerToken({
            server: servergis + '/portal/sharing/rest',
            token: vm.maptoken
          })
          // debugger
          const tileStyle = response.data
          // layer
          vm.currentVectorLayer = new VectorTileLayer({
            style: tileStyle.style,
            opacity: vm.opacity
          })
          // point
          const centerPoint = new Point({
            longitude: vm.longitude,
            latitude: vm.latitude,
            spatialReference: {
              wkid: 4326
            }
          })

          const sym = {
            type: 'picture-marker',
            url: require('@/assets/brains_icons/pingeneral.svg'),
            width: '32px',
            height: '32px',
            yoffset: '15px'
          }
          vm.centerGraphic = new Graphic({
            geometry: centerPoint,
            symbol: sym,
            attributes: {
              tool: 'move'
            }
          })

          // Maps
          vm.currentMap = new ArcGISMap({
            basemap: vm.basemap,
            layers: [vm.currentVectorLayer]
          })
          vm.currentMapView = new MapView({
            container: 'viewDivDEMO' + vm.mapID,
            map: vm.currentMap,
            center: [centerPoint.longitude, centerPoint.latitude],
            constraints: {
              rotationEnabled: false
            },
            zoom: vm.zoom
          })
          const levellegend = tileStyle.legends.filter((item) => vm.zoom > item.minzoom && vm.zoom <= item.maxzoom)[0]
          var unit = tileStyle.unit
          if (unit === 'months') {
            unit = vm.$t('assetData.months')
          } else if (unit === '€\\sqm') {
            unit = vm.$t('marketplace.eur-sqm')
          }

          vm.legendstops = levellegend.fields.map((item) => {
            return {
              label: item[0],
              color: item[1],
              unit: unit
            }
          })
          vm.currentMapView.graphics.add(vm.centerGraphic)

          vm.currentMapView.when(vm.disableMap())
        })
      })
    },
    disableMap() {
      var vm = this
      vm.currentMapView.popup.dockEnabled = true

      // Removes the zoom action on the popup
      vm.currentMapView.popup.actions = []

      // stops propagation of default behavior when an event fires
      function stopEvtPropagation(event) {
        event.stopPropagation()
      }

      // exlude the zoom widget from the default UI
      vm.currentMapView.ui.components = ['attribution']

      // disable mouse wheel scroll zooming on the view
      vm.currentMapView.on('mouse-wheel', stopEvtPropagation)

      // disable zooming via double-click on the view
      vm.currentMapView.on('double-click', stopEvtPropagation)

      // disable zooming out via double-click + Control on the view
      vm.currentMapView.on('double-click', ['Control'], stopEvtPropagation)

      // disables pinch-zoom and panning on the view
      vm.currentMapView.on('drag', stopEvtPropagation)

      // disable the view's zoom box to prevent the Shift + drag
      // and Shift + Control + drag zoom gestures.
      vm.currentMapView.on('drag', ['Shift'], stopEvtPropagation)
      vm.currentMapView.on('drag', ['Shift', 'Control'], stopEvtPropagation)

      // prevents zooming with the + and - keys
      vm.currentMapView.on('key-down', function(event) {
        const prohibitedKeys = ['+', '-', 'Shift', '_', '=', 'ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft']
        const keyPressed = event.key
        if (prohibitedKeys.indexOf(keyPressed) !== -1) {
          event.stopPropagation()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.brainsmap-container {
  height: 100%;
  width: 100%;
  position: relative;
}

div#viewDivDEMO {
  padding: 0;
  margin: 0;
  width: auto;
  height: 100%;
}
.legendcontrol {
  position: absolute;
  bottom: 80px;
  left: -30px;
}

.sub-title {
  font-family: "Montserrat-SemiBold",sans-serif;
}

.sub-title-legend {
  text-align: left;
  margin-left: 15px;
  font-weight: bold;
  color: rgb(90, 90, 90);
  margin-bottom: 7px;
  width: 100%;
}

.legendcoloritem {
  height: 25px;
  width: 25px;
  margin: 2px;
  margin-right: 7px;
  opacity: 0.7;
  border: 1px solid black;
}

.legenditemcontainer {
  display: inline-flex;
  transform: scale(0.9);
  align-items: center;
  color: rgb(102, 101, 101);
}

.container-legend {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 5px;
  font-size: 12px;
}

.iconclosebrains {
  position: absolute;
  right: 2px;
  top: 2px;
  font-size: 1.1em;
  font-weight: bold;
}

</style>
